export default __webpack_public_path__ + "static/salymportimg-1cb40b9255ebe8482798510a42cf5bf3.jpg";